import { Injectable, ComponentFactoryResolver, Injector, ApplicationRef, EmbeddedViewRef } from '@angular/core';
import { AlertCustomComponent } from 'src/app/wings-mobile/shared/alert-custom/alert-custom.component';

@Injectable({
	providedIn: 'root'
})
export class MessageBeep {

	constructor(
		private compFacRes: ComponentFactoryResolver,
		private injector: Injector,
		private appRef: ApplicationRef,
	) {
		this.compFacRes = compFacRes;
		this.injector = injector;
		this.appRef = appRef;
	}

	private success = new Audio();
	private error = new Audio();

	successBeep(): void {
		this.success.src = 'assets/audio/barcode_beep.mp3';
		this.success.load();
		this.success.play();
	}

	errorBeep(): void {
		this.error.src = 'assets/audio/error_beep.mp3';
		this.error.load();
		this.error.play();
	}

	showAlertCustom(title: string, msg: string, elId?: string) {

		this.errorBeep();

		const MODALREF = this.compFacRes.resolveComponentFactory(AlertCustomComponent)
			.create(this.injector);

		MODALREF.instance.modalParams(title, msg, elId);

		this.appRef.attachView(MODALREF.hostView);

		const ELEMENT = (MODALREF.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
		document.body.appendChild(ELEMENT);
	}
}
